var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_c('LoadingIcon',{staticClass:"vehicle-alerts__loading-icon"}):_c('button',{staticClass:"btn btn-warning btn-lg vehicle-alerts-btn",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v(" Set Vehicle Alert ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }